import React from "react";
import { useLocation } from "react-router-dom";
import BackButton from "./BackButton";

/**
 * <PageBackBar />
 * --------------------------------------------------------------
 * Phase 7.3.0 UX Polish — a global "back arrow" toolbar that renders
 * below the sticky header on internal pages.
 *
 * Behavior:
 *   - HIDDEN on home ("/").
 *   - HIDDEN on auth flows (/login, /signup, /auth/*).
 *   - HIDDEN on checkout & shop-success surfaces (they have their own flows).
 *   - HIDDEN on admin (/admin/*) — the AdminShell has its own internal nav.
 *   - VISIBLE everywhere else.
 *
 * Rendered once at the Layout level so individual pages don't need to import
 * BackButton themselves. Pages that already render their own BackButton (e.g.
 * DoshaResultPage, EcosystemTopicPage) continue to work — we keep this bar
 * compact and consistent.
 */
const HIDE_PREFIXES = [
  "/login",
  "/signup",
  "/auth",
  "/admin",
  "/shop/success",
  "/shop/checkout",
  "/checkout",
  "/reset-password",
];

export default function PageBackBar() {
  const { pathname } = useLocation();
  const norm = pathname || "/";

  // Hide on home
  if (norm === "/") return null;

  // Hide on listed prefixes
  for (const p of HIDE_PREFIXES) {
    if (norm === p || norm.startsWith(p + "/")) return null;
  }

  return (
    <div
      className="app-container pt-5 pb-1 flex items-center"
      data-testid="page-back-bar"
    >
      <BackButton fallback="/" testId="page-back-button" />
    </div>
  );
}
